<!--
StatusTag Component — wraps PrimeVue Tag for status / badge labels.

Use for short categorical indicators (e.g., status pills, type labels).
For key/value pairs use <key-value-tag>; for counters use <Badge>.
-->

<template>
  <PrimeTag v-bind="$attrs">
    <slot />
  </PrimeTag>
</template>

<script setup lang="ts">
import PrimeTag from 'primevue/tag';

defineOptions({ name: 'StatusTag', inheritAttrs: false });
</script>
